import Modal from './Modal';

export default function FormModal({
  isOpen,
  onClose,
  onSubmit,
  title,
  description,
  children,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  submitDisabled = false,
  cancelDisabled = false,
  errorMessage = '',
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      hideFooter
    >
      <form onSubmit={onSubmit} className="modal-form">
        {errorMessage ? (
          <p className="modal-error">
            {errorMessage}
          </p>
        ) : null}

        {children}

        <div className="modal-actions">
          <button
            type="button"
            onClick={onClose}
            disabled={cancelDisabled}
            className="button"
          >
            {cancelLabel}
          </button>

          <button
            type="submit"
            disabled={submitDisabled}
            className="button button-primary"
          >
            {submitLabel}
          </button>
        </div>
      </form>
    </Modal>
  );
}
